import { debounce } from 'lodash-es'
import { useLocale, useTranslations } from 'next-intl'

import { MAX_USING_FEE, MIN_USING_FEE } from '@/entities/map'
import { Slider } from '@/shared/ui'

import {
  ENGLISH_USING_FEE_VALUE_FORMAT,
  USING_FEE_VALUE_FORMAT,
} from './value-format'
import { Description, Title } from '../../common/layout'

type Props = {
  ref: (element: HTMLDivElement) => void
  value: number[]
  onValueChange: (value: number[]) => void
  className?: string
}

export const UsingFeeInDialogView = ({
  ref,
  value,
  onValueChange,
  className,
}: Props) => {
  const locale = useLocale()
  const isEnglish = locale === 'en'

  const t = useTranslations('filter')

  return (
    <div className={className} ref={ref}>
      <div className="mb-1 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Title className="mb-0">{t('price.title')}</Title>
          <Description>{t('price_subtitle')}</Description>
        </div>
      </div>
      <Slider.Root
        value={value}
        onValueChange={debounce(onValueChange, 500)}
        min={MIN_USING_FEE}
        max={MAX_USING_FEE}
        step={50000}
        minStepsBetweenThumbs={1}
        valueFormat={
          isEnglish ? ENGLISH_USING_FEE_VALUE_FORMAT : USING_FEE_VALUE_FORMAT
        }
      >
        <Slider.Track />
        <Slider.RangeInput
          {...(isEnglish && {
            inputClassName: 'gap-0 *:text-start',
          })}
        />
      </Slider.Root>
    </div>
  )
}
